/* @flow */

import React from 'react';
import { Segment, Grid } from 'semantic-ui-react';
import OctoResourceCard from 'shared/components/OctoResourceCard';
import GalleryImageForm from './GalleryImageForm';

type Props = {
  image: GalleryContentImage,
  imageCount: number,
  defaultResourceStrategy: ResourceStrategy,
  onUpdate: (image: GalleryContentImage) => void,
  onReorder: (image: GalleryContentImage, order: number) => void,
  onDelete: (image: GalleryContentImage) => void,
};

const GalleryImage = ({
  image,
  imageCount,
  defaultResourceStrategy,
  onUpdate,
  onReorder,
  onDelete,
}: Props) => {
  const titleChanged = (title: string) =>
    onUpdate({
      ...image,
      title,
    });

  const resourceUpdated = (resource: CatalogResource) =>
    onUpdate({
      ...image,
      image: resource,
    });

  const resourceDeleted = () =>
    onUpdate({
      ...image,
      image: undefined,
    });

  return (
    <Segment attached>
      <Grid>
        <Grid.Column width={6} verticalAlign="middle">
          <GalleryImageForm
            image={image}
            imageCount={imageCount}
            onTitleChange={titleChanged}
            onOrderChange={onReorder}
            onDelete={onDelete}
          />
        </Grid.Column>
        <Grid.Column width={10}>
          <OctoResourceCard
            strategy={defaultResourceStrategy}
            resource={image.image}
            onUpdated={resourceUpdated}
            onDeleted={resourceDeleted}
          />
        </Grid.Column>
      </Grid>
    </Segment>
  );
};

export default GalleryImage;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/gallery/GalleryImage.js